import { AuthContext } from "navigation/AuthProvider";
import { useContext } from "react";

export const useAuth = () => {
  const { user } = useContext(AuthContext);
  return {
    department: user?.department,
    manager: user?.manager,
    position: user?.position,
    role: user?.role,
    user: user?.user,
    line_manager: user?.user?.line_manager,
  };
};
